import { INGREDIENT_BY_ID } from '../data/ingredients.js';
import VideoCard from './VideoCard.jsx';

export default function Showdown({ tournament, onVote }) {
  const champion = INGREDIENT_BY_ID.get(tournament.champion);
  const challenger = INGREDIENT_BY_ID.get(tournament.challenger);
  const progress = (tournament.round / tournament.totalRounds) * 100;

  return (
    <main className="mx-auto flex min-h-dvh max-w-3xl flex-col px-3 py-3 sm:px-6 sm:py-10">
      <header className="mb-3 sm:mb-6">
        <div className="flex items-center justify-between text-xs font-bold uppercase tracking-wide text-showdown-cream/80 sm:text-base">
          <span>
            Round {tournament.round} of {tournament.totalRounds}
          </span>
          <span className="text-showdown-pink">Which reaction do you prefer?</span>
        </div>
        <div
          className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-showdown-ink sm:mt-2 sm:h-3"
          role="progressbar"
          aria-valuenow={tournament.round}
          aria-valuemin={1}
          aria-valuemax={tournament.totalRounds}
          aria-label="Showdown progress"
        >
          <div
            className="h-full rounded-full bg-showdown-pink transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </header>

      <p aria-live="polite" className="sr-only">
        Round {tournament.round} of {tournament.totalRounds}. Two new reactions loaded.
      </p>

      <div className="flex flex-1 flex-col justify-center gap-2 sm:gap-6">
        <div className="grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:gap-6">
          <VideoCard reaction={champion} label="Reaction A" accent="blue" active onSelect={onVote} />
          <VideoCard reaction={challenger} label="Reaction B" accent="green" active onSelect={onVote} />
        </div>

        <p className="text-center text-xs text-showdown-cream/60 sm:text-base">
          Tap the reaction you like better. Ingredients stay secret until you finish all{' '}
          {tournament.totalRounds} rounds.
        </p>
      </div>
    </main>
  );
}
